module.exports = __webpack_public_path__ + "d1d0c41e8befbe8621f65a9ed1038a16.png";